import { RENDER_NONCONVERSATIONAL_FILTER, SET_ADD_MANUALLY_ROW, UPDATE_NONCONVERSATIONAL_FILTERS } from "../constants";

let initialState = {};

export const filterReducer = (state = initialState, action) => {
	switch (action.type) {
		case RENDER_NONCONVERSATIONAL_FILTER:
		case UPDATE_NONCONVERSATIONAL_FILTERS:
			return { ...state, ...action.data };
			case SET_ADD_MANUALLY_ROW:
			return { ...state, addManuallyRow: action.data };
		default:
			return state;
	}
};
